import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const SidebarContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: "transparent",
  height: "100%",
  boxSizing: "border-box",
  display: "flex",
  gap: "24px",
}));

export const FixedSideBar = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  height: "100%",
  width: "72px",
  maxWidth: "72px",
  minWidth: "72px",
  padding: "16px",
  boxSizing: "border-box",
  fontSize: "18px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

export const ButtonsContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: "transparent",
  gap: "16px",
  alignItems: "center",
  "& button": {
    color: theme.palette.text.primary,
  },

  "& .MuiAvatar-root": {
    width: "50px",
    height: "50px",
  },
}));

export const LogoBlock = styled(Grid)({
  width: "100%",
  minHeight: "80px",
  display: "flex",
  justifyContent: "center",
});

export const LogoContainer = styled("img", {
  shouldForwardProp: (prop) => prop !== "height",
})<{ height?: number }>(
  {
    width: "auto",
    height: "80px",
    borderRadius: "15px",
    objectFit: "contain",
    alignSelf: "center",
  },
  ({ height }) => ({
    ...(height && { height: `${height}px` }),
  })
);
